var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputersSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.183 0c.497-.002.926.336 1.024.81h0l1.776 8.978c.056.292-.027.593-.226.82-.198.226-.492.357-.798.356h0l-5.598-.001v1.859l2.29.001c.177 0 .324.125.358.291l.008.074c0 .201-.164.365-.365.365h0-2.656c-.046 0-.09-.009-.13-.024h-3.57c-.238 0-.413-.217-.354-.44l.56-2.126H2.817c-.456.003-.855-.28-.993-.693l-.032-.115L.018 1.177C-.04.885.043.583.243.355.442.13.733 0 1.04 0h0zM8.631 8.399H6.932l-1.166 4.424H8.63V8.399zM13.185.705H1.04C.948.705.86.745.8.812.743.877.72.963.735 1.046h0L2.51 10.02c.03.14.156.24.306.24h0l2.873-.001.606-2.299c.042-.156.187-.265.354-.265h2.348c.202 0 .365.158.365.352v2.212h5.6c.068 0 .135-.021.19-.06l.049-.046c.057-.065.08-.152.065-.234h0L13.49.945c-.028-.14-.156-.24-.305-.24h0zm-1.54 6.675c.198-.038.39.085.43.276h0l.136.645c.04.19-.088.377-.285.415-.198.04-.39-.084-.43-.275h0l-.136-.645c-.04-.19.088-.377.285-.416zm1.352 0c.198-.039.39.085.43.276h0l.136.643c.04.191-.088.377-.285.416-.198.039-.39-.084-.43-.275h0l-.136-.644c-.04-.19.087-.377.285-.416z",
    transform: "translate(-135 -426) translate(99 106) translate(0 309.217) translate(36 11.596) translate(0 .966)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputersSmall);
export default __webpack_public_path__ + "static/media/computers-small.4b3acf55.svg";
export { ForwardRef as ReactComponent };